<template>
  <div>
    <div v-for="area in Object.keys(showingHits)" :key="area">
      <div class="hiq-detail-planning-list__area-title-wrapper">
        <span class="hiq-detail-planning-list__area-title">{{ area }}</span>
      </div>
      <ul class="hiq-detail-planning-list__area-list">
        <Hit
          v-for="hit in showingHits[area]"
          :key="hit.id"
          :hit="hit"
          ref="hit"
        />
      </ul>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import Hit from "./Hit.vue";
import { ISearchHit, ISearchHits } from "../store/state";
interface HitListProps {}

export default Vue.extend<{}, {}, {}, HitListProps>({
  name: "HitList",
  props: {},
  computed: {
    hits() {
      return this.$store.getters.hits;
    },
    showingHits() {
      const currentPage = this.$store.getters.currentPage;
      const count = this.$store.getters.count;
      const filteredHits: ISearchHits = this.$store.getters.filteredHits;
      const paginatedHits: ISearchHits = {};
      let amountAdded = 0;

      Object.keys(filteredHits).forEach((area) => {
        filteredHits[area].forEach((hit: ISearchHit) => {
          if (amountAdded < count * (currentPage + 1)) {
            if (area in paginatedHits) {
              paginatedHits[area].push(hit);
            } else {
              paginatedHits[area] = [hit];
            }
            amountAdded++;
          }
        });
      });

      this.$store.commit({
        type: "setCurrentlyShowingHits",
        payload: filteredHits,
      });
      this.$store.commit({
        type: "setAmountOfShowingHits",
        payload: amountAdded,
      });
      return paginatedHits;
    },
  },
  components: {
    Hit,
  },
  updated() {
    if (this.$store.getters.shouldFocus) {
      const hitsref = this.$refs.hit as Array<any> | undefined;
      const hitToFocus =
        hitsref && hitsref[this.$store.getters.focusIndex];
      const listElementToFocus = hitToFocus && hitToFocus.$el;
      if (listElementToFocus) {
        const anchor = listElementToFocus.getElementsByTagName("a")[0];
        anchor.focus();
        const y =
          listElementToFocus.getBoundingClientRect().top +
          window.pageYOffset -
          85;
        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
      this.$store.commit({
        type: "shouldFocus",
        payload: {
          shouldFocus: false,
          index: 0,
        },
      });
    }
  },
});
</script>
